"use client";

import { useDiscount } from "~/hooks/use-discount";

/**
 * Global discount handler that reads discount codes from URL parameters
 * and stores them in cookies. This component doesn't render anything visible.
 */
export function DiscountHandler() {
  // This hook will automatically:
  // 1. Read the 'code' query parameter from the URL
  // 2. Validate it against the database
  // 3. Store valid codes in cookies
  useDiscount();

  return null;
}
